//import React from 'react';
//import ReactQuill from 'react-quill';
import GeckoFieldBase from '../_base.jsx';
//import '../../../../../../node_modules/react-quill/dist/quill.snow.css';
// https://www.npmjs.com/package/react-quill

class GeckoFieldRichtext extends GeckoFieldBase {
  //This has to work differetnly from other fields
  handleChange = (value) => {
    return this.props.handler.bind(
      this,
      this.field().key,
      this.prepareValue(value)
    )();
  };

  render() {
    return null;
    // return (
    // 	<ReactQuill
    // 		value={this.value()}
    // 		onChange={this.handleChange.bind(this)}
    // 		readOnly={this.isDisabled()}
    // 		placeholder={this.config().placeholder} />
    // );
  }
}

export default GeckoFieldRichtext;
